import {usePostHogTrack, POSTHOG_EVENTS} from 'analytics';
import {Container, ExternalContainer, BackgroundImage, TextWrapper, Price, Highlight, Title} from './styled';
import {usePathToOfferView} from '../usePathToOfferView';

type Props = {
  id: string;
  title: string;
  price: string;
  category?: string;
  highlight: string;
  imageUrl: string;
  className?: string;
  href?: string;
};
const ShortOfferCard = ({className, id, title, price, category, highlight, imageUrl, href}: Props) => {
  const {getFullPathToOfferView} = usePathToOfferView();
  const {trackOfferEvent} = usePostHogTrack();

  const handleClick = () => {
    trackOfferEvent(POSTHOG_EVENTS.OFFER_DETAIL_OPENED, {
      id,
      title,
      price,
      category,
    });
  };

  const content = (
    <>
      <TextWrapper>
        <Title>{title}</Title>
        <Price>{price}</Price>
        <Highlight>{highlight}</Highlight>
      </TextWrapper>
      <BackgroundImage src={imageUrl} />
    </>
  );

  if (href) {
    return (
      <ExternalContainer href={href} target="_blank" rel="nofollow" className={className} onClick={handleClick}>
        {content}
      </ExternalContainer>
    );
  }

  return (
    <Container to={getFullPathToOfferView(id)} className={className} onClick={handleClick}>
      {content}
    </Container>
  );
};

export {ShortOfferCard};
